import { MruCache } from "owa-mru-cache";
import type ConversationItemParts from "./schema/ConversationItemParts";
import shouldReduceMemoryForDevice from "../utils/shouldReduceMemoryForDevice";

export type ConversationMruCache = MruCache<ConversationItemParts>;

let conversationCache: ConversationMruCache | null = null;

export default function getConversationCache(): ConversationMruCache {
    if (conversationCache == null) {
        const cacheSize = shouldReduceMemoryForDevice() ? 10 : 50;
        conversationCache = new MruCache<ConversationItemParts>("ConversationItemParts", cacheSize);
    }
    return conversationCache;
}
